/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import _ from "lodash";
import axios from "../../../api/axiosService";
import Skeleton from "../../../Components/Skeleton";

export default function Project({ ...props }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `/api/radarSingle/list?artistId=${props.id}`,
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (props.id) fetchData();
  }, [props.id]);

  if (isLoading) {
    return (
      <div className="project-tab">
        <div className="content">
          <div className="project-list">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                key={`project-skeleton-${index}`}
                className="project-item flex flex-col justify-between"
              >
                <div>
                  <Skeleton className="w-full aspect-square" />
                  <Skeleton.Text className="w-3/4 h-6 mt-[30px]" />
                </div>
                <div className="action normal-text w-full flex gap-0 mt-[50px] max-sm:flex-col max-sm:gap-[30px]">
                  <Skeleton className="w-1/2 max-sm:w-full h-16" />
                  <Skeleton className="w-1/2 max-sm:w-full h-16" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="project-tab">
      <div className="content">
        <div className="project-list">
          {data?.length > 0 &&
            data.map((value) => (
              <div
                key={value.id}
                className="project-item flex flex-col justify-between"
              >
                <div>
                  <img
                    src={_.get(value, "image", "")}
                    alt={_.get(value, "image")}
                  />
                  <div className="title title-2">{value.title}</div>
                </div>
                <div className="action normal-text w-full">
                  <a
                    className="w-1/2 max-sm:w-full"
                    href={value.youtubeUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ flex: 1 }}
                  >
                    <button
                      className="youtube-btn"
                      style={{ width: "100%" }}
                    >
                      YouTube
                    </button>
                  </a>

                  {value.spotifyUrl && (
                    <a
                      className="w-1/2 max-sm:w-full"
                      href={value.spotifyUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="spotify-btn w-full -ml-px">
                        Digital Audio
                      </button>
                    </a>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
